import httpClient from '../../httpClient';

/**
 *
 * @returns {Promise<{ data: { cluster: String, key: String } }>}
 */
export const getConfig = () =>
  httpClient({
    method: 'GET',
    url: '/pusher/config',
  });
